import Image1 from "../../assets/testimonial1.png";
import Image2 from "../../assets/testimonial2.png";
import Image3 from "../../assets/testimonial3.png";

export const Data = [
    {
      id: 1,
      image: Image1,
      title: "Portfolio",
      description:
        "Personal Portfolio, all aspects of the personal skils & projects were followed step by step and with good results.",
    },
    {
      id: 2,
      image: Image2,
      title: "Speak Up Buddy",
      description:
        "This application analyzes the facial expression of users with voice modulation & checks perfect or not.",
    },
    {
      id: 1,
      image: Image3,
      title: "Covid-19 Tracker",
      description:
        "A really good Covid-19 Tracker, all aspects of the project which Covid-19 Tracker using API with good results.",
    },
  ];
